const comments = [
  {
    name: '影视达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20with%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20simple%20beige%20background%2C%20headshot%20photography%20style%20with%20soft%20shadows&width=100&height=100&seq=avatar-1-51video&orientation=squarish',
    time: '2小时前',
    text: '51视频真的太方便了！之前要在好几个网站之间切换找资源，现在一个平台就搞定了。狂飙全集就是在这儿看完的，高清不卡顿，体验一级棒！',
    like: 326,
  },
  {
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20Chinese%20woman%20with%20natural%20lighting%2C%20gentle%20smile%2C%20clean%20simple%20cream%20background%2C%20professional%20headshot%20style%20with%20soft%20natural%20light&width=100&height=100&seq=avatar-2-51video&orientation=squarish',
    time: '5小时前',
    text: '作为重度电视剧爱好者，每天都要来看看更新列表。更新速度真的快，基本上电视台播完这边就有了。而且分类很清楚，找剧特别方便。推荐给了身边所有朋友！',
    like: 218,
  },
  {
    name: '电影老炮儿',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%20with%20warm%20dramatic%20lighting%2C%20sophisticated%20and%20thoughtful%20expression%2C%20clean%20simple%20warm%20gray%20background%2C%20editorial%20portrait%20photography%20style&width=100&height=100&seq=avatar-3-51video&orientation=squarish',
    time: '1天前',
    text: '用了好几个月了，资源非常全。从老电影到最新院线大片都有，画质也很棒。最满意的是播放流畅度，基本没有遇到过卡顿的情况，这点比其他平台强太多了。',
    like: 487,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">用户热评</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">真实用户反馈，听听大家对51视频的评价</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto">
          {comments.map((item) => (
            <div
              key={item.name}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 hover:border-primary-200 transition-all duration-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{item.like}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}